// The Main Site Object
let Home = {

    header         : document.querySelector('.header'),
    schiopBtnOpen  : document.querySelector('.schioppettino-btn'),
    schiopBtnClose : document.querySelector('.schioppettino-btn-close'),
    schiopSection  : document.querySelector('.schioppettino'),

    // Init Function
    liftoff : () => {
        Home.onClickShowSection()
        Home.onClickHideSection()
    },

    // Show/Hide The Main Navigation
    onClickShowSection : () => {
        Home.schiopBtnOpen.addEventListener('click' , () => {
            Home.schiopBtnClose.classList.toggle('active')
            Home.schiopSection.classList.toggle('active')
            Home.schiopSection.scrollTo(0,0)
            Home.header.classList.toggle('active-schiop')
            document.documentElement.classList.toggle('no-scroll')
            document.body.classList.toggle('no-scroll')
        })
    },

    onClickHideSection : () => {
        Home.schiopBtnClose.addEventListener('click' , () => {
            Home.schiopBtnClose.classList.toggle('active')
            Home.schiopSection.classList.toggle('active')
            Home.header.classList.toggle('active-schiop') 
            Home.schiopSection.scrollTo(0,0)
            document.documentElement.classList.toggle('no-scroll')
            document.body.classList.toggle('no-scroll')
        })
    }



}

// Launch The Script
Home.liftoff()